<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.6 19.6004C14.9021 19.6004 19.2 15.3025 19.2 10.0004C19.2 4.69831 14.9021 0.400391 9.6 0.400391C4.29792 0.400391 0 4.69831 0 10.0004C0 15.3025 4.29792 19.6004 9.6 19.6004Z" :fill="`url(#${paintId})`" />
        <g :filter="`url(#${filterId})`">
            <path d="M9.16337 16.4004V15.1521C7.2498 14.9897 5.66588 13.9187 5.60156 12.2051V12.1977L7.00056 12.1903V12.2051C7.14528 13.121 7.76438 13.8522 9.16337 13.9925V10.4399L8.97845 10.3955C6.97644 9.95238 5.89905 9.13253 5.89905 7.68487V7.67009C5.89905 6.08948 7.25784 5.01112 9.16337 4.84863V3.60039H10.1282V4.84863C11.9855 5.00373 13.4247 6.11164 13.489 7.73657V7.74395L12.09 7.75134V7.73657C11.9855 6.74684 11.2136 6.1338 10.1282 6.00824V9.39843L10.3774 9.45013C12.4438 9.90806 13.6016 10.691 13.6016 12.2347V12.2494C13.6016 14.0221 12.0257 15.0192 10.1282 15.1595V16.4004H9.16337ZM7.29805 7.59623C7.29805 8.31268 7.78046 8.87402 9.16337 9.18423V6.00824C7.94126 6.16334 7.29805 6.8724 7.29805 7.58146V7.59623ZM10.1764 10.6614L10.1282 10.6541V14.0073C11.6237 13.8965 12.2026 13.2022 12.2026 12.3528V12.3381C12.2026 11.533 11.7684 11.016 10.1764 10.6614Z" fill="white" />
        </g>
        <defs>
            <filter :id="filterId" x="5.60156" y="3.60039" width="8.4" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx="0.4" dy="0.2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.999349 0 0 0 0 0.691834 0 0 0 0 0.330839 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_26_2071" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_26_2071" result="shape" />
            </filter>
            <linearGradient :id="paintId" x1="1.28" y1="20.8804" x2="17.28" y2="4.88039" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFAF36" />
                <stop offset="0.5" stop-color="#FFF1A8" />
                <stop offset="1" stop-color="#FDD717" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'BalanceIcon',
    computed: {
        paintId() {
            return `paint0_balance_${this._uid}`
        },
        filterId() {
            return `filter0_balance_${this._uid}`
        }
    }
}
</script>
